import React from 'react';
import { inject, observer } from 'mobx-react';
import H5Avatar from './h5';
import PCAvatar from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface AvatarProps {
    app?: AppStore;
    variant?: 'pc' | 'h5';
    site?: SiteStore;
    user?: UserAction;
    data?: any;
    size?: number;  // 头像尺寸
    avatarUrl?: any;    // 头像图片
    userCode?: any;    // 用户Id
    userClick?: Function;    // 头像点击事件
    showOfficialTag?: boolean;  // 是否显示官方标识，默认显示
    titleMark?: any // 官方
    level?: number | string; // 用户等级 1-7
    officialSize?: any;
    levelBadgeWidth?: number;
    levelBadgeHeight?: number;
    isOpenBlank?: any
}

type AvatarAllProps = AvatarProps & RouteComponentProps;

@inject('app', 'site', 'user')
@observer
class Avatar extends React.Component<AvatarAllProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('组件组件');
    }

    // 点击头像，跳转到个人中心
    userClick = () => {
        console.log(this.props.userCode, '用户id')
        // 支持路由跳转
        if (this.props.history && this.props.userCode) {
            if(this.props.isOpenBlank) {
                window.open(`/user/${this.props.userCode}`)
            } else {
                this.props.history.push(`/user/${this.props.userCode}`);
            }
            
        }
        // this.props.userClick && this.props.userClick();
    }

    render() {
        const { site, app, data, variant, ...props } = this.props;
        const platform = variant || app?.platform || 'h5';
        if (platform === 'pc') {
            return <PCAvatar userClick={this.userClick} {...props} />;
        } else {
            return <H5Avatar userClick={this.userClick} {...props} />;
        }


    }
}

export default withRouter(Avatar);
